/** Avatar's initials. From an email because a local part is mechanical, while splitting a
 *  person's name is a guess: `''` when there is no letter, and Avatar draws the icon. */
export function initialsFromEmail(email: string): string {
  const localPart = email.split('@')[0] ?? ''
  const letters = localPart.replace(/[^a-z]/gi, '')
  return letters.slice(0, 2).toUpperCase()
}

/** A club's initials, for `ClubCrest`'s shield. Why abbreviations go by shape and not by a
 *  list of legal forms: packages/ui/docs/stemma-mancante-iniziali.md. */
export function initialsFromClubName(name: string): string {
  const tokens = name.split(/\s+/).filter((one) => one !== '')
  const words = tokens.filter((one) => !looksLikeAbbreviation(one)).map(lettersOf)
  // Everything dropped means the name IS its abbreviation: better its own letters than none.
  const usable = words.filter((one) => one !== '')
  const [first, second] = usable.length > 0 ? usable : tokens.map(lettersOf).filter(Boolean)

  if (first === undefined) return ''
  if (second === undefined) return first.slice(0, 2).toUpperCase()
  return `${first.slice(0, 1)}${second.slice(0, 1)}`.toUpperCase()
}

/** A player's initials, for a scheda with no photo: the first letter of the given name and of the
 *  family name. `''` when neither has a letter, and one letter when only one does. */
export function initialsFromPersonName(givenName: string, familyName: string): string {
  return `${firstLetterOf(givenName)}${firstLetterOf(familyName)}`
}

function firstLetterOf(name: string): string {
  return (/\p{L}/u.exec(name)?.[0] ?? '').toUpperCase()
}

function lettersOf(token: string): string {
  return token.replace(/[^\p{L}]/gu, '')
}

function looksLikeAbbreviation(token: string): boolean {
  if (token.includes('.')) return true
  const letters = lettersOf(token)
  return letters.length <= 4 && letters === letters.toUpperCase()
}
